import { z } from 'zod';

import { BorrowerId, PrincipalModificationId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GeneratePrincipalModificationCancelledSideEffectContext = BaseLoanIdSideEffect.extend({
  borrowerIds: z.array(BorrowerId),
  principalModificationId: PrincipalModificationId,
});

export const GeneratePrincipalModificationCancelledSideEffect =
  GeneratePrincipalModificationCancelledSideEffectContext.extend({
    type: z.literal('generatePrincipalModificationCancelled'),
  });
export type GeneratePrincipalModificationCancelledSideEffect = z.infer<
  typeof GeneratePrincipalModificationCancelledSideEffect
>;
